import { Component, OnInit } from '@angular/core';
import { FantasyGame, FantasyGameQuery, FantasyGameService, GameStatus } from '@fgb/core';
import { combineLatest, map, Observable } from 'rxjs';
import * as _moment from 'moment';
const moment = _moment;
@Component({
  selector: 'fgb-fantasy-up-next',
  templateUrl: './fantasy-up-next.component.html',
  styleUrl: './fantasy-up-next.component.scss',
})
export class FantasyUpNextComponent implements OnInit {
  upNextGames$: Observable<FantasyGame[]>;

  constructor(private fantasyQuery: FantasyGameQuery, private fantasyGameService: FantasyGameService) {}

  ngOnInit(): void {
    this.fantasyGameService.fetchFantasyGamesV2(10, false, true).subscribe();

    this.upNextGames$ = combineLatest([this.fantasyQuery.selectAll(), this.fantasyQuery.selectCurrentGames()]).pipe(
      map(([allGames, currentGames]) => {
        if (!allGames.length) {
          return [];
        }

        let currentGameIds: number[] = [];

        //if there are currentGames
        currentGameIds = [...currentGameIds, currentGames[0]?.GameId];

        //exclude the first not Processed game
        currentGameIds = [...currentGameIds, allGames.find((game) => game.Status !== GameStatus.Processed)?.GameId ?? 0];

        if (allGames?.length !== 0) {
          allGames.forEach((game) => {
            if (game.Status === GameStatus.Processed) {
              currentGameIds = [...currentGameIds, game.GameId];
            }
          });
        }

        const now = Date.now();

        return allGames
          .filter((game) => {
            const gameTime = new Date(game.GameDate).getTime();

            return !currentGameIds.includes(game.GameId) && gameTime > now && game.Status !== GameStatus.Processed;
          })
          .map((game) => {
            const gameTime = new Date(game.GameDate).getTime();

            return {
              ...game,
              _gameTime: gameTime,
              Date: moment.utc(game.GameDate).local().format('MMM DD y'),
              Time: moment.utc(game.GameDate).local().format('H:mm'),
            };
          })
          .sort((a, b) => a._gameTime - b._gameTime)
          .slice(0, 5);
      })
    );
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/images/broken-image.png';
  }
}
